import { useTranslation } from "react-i18next"
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material"

import React, { useEffect, JSX } from "react"
import { observer } from "mobx-react-lite"
import { useStore } from "../../contexts/store"
import { t } from "i18next"

// message from thread
const NodeSelector = ({ value, onChange, allowPod=true, allowFolders=true }: {value:string, onChange:Function, allowPod?:Boolean, allowFolders?:Boolean}) => {

  const { podStore } = useStore()
  const pod = podStore.pod
  if (!pod) return null

  const material = pod.getMaterialList(false)
  const listing:JSX.Element[]  = []
  if (allowPod) listing.push(<MenuItem value={'*'}>{t('Entire Pod')}</MenuItem>)

  for(var item of material) {
    listing.push(<MenuItem value={item.id} disabled={(item.itemType === 'folder') && !allowFolders}>{item.name}</MenuItem>)
    for(var child of item.children) {
      listing.push(<MenuItem value={child.id} sx={{ml:5}}>{child.name}</MenuItem>)
    }
  }

  return (
    <Box>
      <FormControl sx={{ m: 1, minWidth: 120, backgroundColor: "white" }} size="small">
        <Select
          value={value}
          onChange={(event: SelectChangeEvent) => onChange(event.target.value)}
        >
          {listing}
        </Select>
      </FormControl>
    </Box>
  )
}

export default observer(NodeSelector)